module.exports = __webpack_public_path__ + "static/media/chave.f03fbed2.svg";